module.exports = __webpack_public_path__ + "img/top-title-bg.56f5a2f5.jpg";